import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import * as moment from 'moment';
import ptLogo from 'web/assets/images/ptLogoSmallImg.png';

const styles = StyleSheet.create({
    pageWrapper: { padding: '20px 50px 0 50px' },
    orderWrapper: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' },
    imageStyle: { width: 200, height: 40, alignSelf: 'flex-end' },
    titleStyle: { fontSize: 14, textAlign: 'center', marginVertical: 10 },
    subTitleStyle: { marginVertical: 5, fontSize: 11, fontWeight: 'bold' },
    highlightedText: { fontSize: 10, fontWeight: 'bold' },
    normalText: { fontSize: 9, color: '#5d5d5d' },
    signInText: { fontSize: 9, color: '#5d5d5d', marginVertical: 5 },
    underlinedText: { fontSize: 9, textDecoration: 'underline' },
    fieldWrapper: { marginVertical: 5 },
    label: { fontSize: 10, marginVertical: 5, fontWeight: 'bold' },
    fieldData: { display: 'flex', flexDirection: 'row', marginVertical: 5 },
    marginTop: { marginTop: 5 },
    question: { width: '160px', fontSize: '10px', fontWeight: 'bold' },
    answer: { fontSize: '10px', color: '#5d5d5d' },
    separator: { marginVertical: 10, borderBottom: '0.5px solid #000' },
    rowView: { display: 'flex', flexDirection: 'row', gap: '50px' },
    sectionTitle: { fontSize: 10, fontWeight: 'bold', marginVertical: 10 }
});

const BOLFormatDoc = ({ pdfDocumentData }) => {
    const vendorName = localStorage.getItem('companyName');

    return (
        <Document>
            <Page size="A4" style={styles.pageWrapper}>
                <View style={styles.orderWrapper}>
                    <Image src={ptLogo} style={styles.imageStyle} />
                </View>
                <Text style={styles.titleStyle}>Pallet Pickup Sort Form</Text>
                <Text style={styles.subTitleStyle}>
                    <Text style={styles.highlightedText}>Supplier Instructions: </Text>
                    <Text style={styles.normalText}>Please present this pickup form to the facility for signature to acknowledge proof of pickup. Once the pallet load has been sorted, please populate the quantities per pallet type in the supplier section below, sign, and upload this document to the PalletTrader portal. </Text>
                    <Text style={styles.underlinedText}>This document should be uploaded no more than 72 hours after pickup.</Text>
                </Text>
                <View style={styles.fieldWrapper}>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Pickup Order #:</Text>
                        <Text style={styles.answer}>{pdfDocumentData?.orderId}</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Pickup Facility Name:</Text>
                        <Text style={styles.answer}>{pdfDocumentData?.pickupLocation?.locationName}</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Pickup Facility Address:</Text>
                        <Text style={styles.answer}>{pdfDocumentData?.pickupLocation?.address1}, {pdfDocumentData?.pickupLocation?.city}, {pdfDocumentData?.pickupLocation?.state} {pdfDocumentData?.pickupLocation?.zipCode}</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Requested Pick Up Date:</Text>
                        <Text style={styles.answer}>{moment(pdfDocumentData?.pickupDate).format('MM/DD/YYYY')} {pdfDocumentData.pickupAppointmentStartTime} - {pdfDocumentData.pickupAppointmentEndTime}</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Facility PO #:</Text>
                        <Text style={styles.answer}>{pdfDocumentData?.poNumber}</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Estimated Pallet Qty:</Text>
                        <Text style={styles.answer}>{pdfDocumentData?.quantity}</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Equipment:</Text>
                        <Text style={styles.answer}>{pdfDocumentData.loadingRequirement === 'DROP_TRAILER' ? 'Drop Trailer' : pdfDocumentData.loadingRequirement === 'LIVE_LOAD' ? 'Live Load' : 'NA'}</Text>
                    </View>
                </View>
                <View style={styles.separator}></View>
                <Text style={styles.sectionTitle}>FACILITY SECTION: To be completed by the pickup facility at the time of pickup.</Text>
                <View style={styles.fieldWrapper}>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Total Pallets Picked Up:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <Text style={styles.signInText}>By signing this form, I acknowledge that the load of pallets has successfully been picked up at the total quantity listed is as complete and accurate to the best of my knowledge and belief.</Text>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Name:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Signature:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Date:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                </View>
                <View style={styles.separator}></View>
                <Text style={styles.sectionTitle}>SUPPLIER SECTION: To be completed by the supplier after the pallets have been sorted.</Text>
                <View style={styles.fieldWrapper}>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Supplier Name:</Text>
                        <Text style={styles.answer}>{vendorName}</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Trailer:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, ...styles.marginTop }}>Grade A:</Text>
                        <Text style={{ ...styles.answer, ...styles.marginTop }}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Grade A1:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Grade B:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Odd:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Scrap:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                </View>
                <View style={styles.fieldWrapper}>
                    <View style={styles.fieldData}>
                        <Text style={{ ...styles.question, width: '160px' }}>Total Pallets:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <Text style={styles.signInText}>By signing this form, I hereby acknowledge that this form is complete and accurate.</Text>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Name:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Signature:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                    <View style={styles.fieldData}>
                        <Text style={styles.question}>Date:</Text>
                        <Text style={styles.answer}>__________________</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default BOLFormatDoc;